import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "wago-section-label" }
const _hoisted_2 = { class: "asset-stats-grid" }
const _hoisted_3 = { class: "asset-stat-header" }
const _hoisted_4 = { class: "asset-stat-value" }
const _hoisted_5 = { class: "wago-section-label" }
const _hoisted_6 = { class: "wago-phase-grid" }
const _hoisted_7 = { class: "asset-stat-header" }
const _hoisted_8 = { class: "wago-phase-values" }
const _hoisted_9 = { class: "wago-phase-col" }
const _hoisted_10 = { class: "asset-stat-value" }
const _hoisted_11 = { class: "wago-phase-col" }
const _hoisted_12 = { class: "asset-stat-value" }
const _hoisted_13 = { class: "wago-phase-col" }
const _hoisted_14 = { class: "asset-stat-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wago-params-panel", { 'dark-mode': _ctx.isDarkMode }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('components.assetDetails.wagoParams.sectionBasic')), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.basicRows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row.key,
          class: "asset-stat"
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("i", {
              class: _normalizeClass(row.icon)
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(row.label), 1)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(row.value), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('components.assetDetails.wagoParams.sectionPhases')), 1),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phaseRows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          key: row.key,
          class: "asset-stat"
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("i", {
              class: _normalizeClass(row.icon)
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(row.label), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[0] || (_cache[0] = _createElementVNode("span", { class: "wago-phase-label" }, "L1", -1)),
              _createElementVNode("span", _hoisted_10, _toDisplayString(row.l1), 1)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "wago-phase-label" }, "L2", -1)),
              _createElementVNode("span", _hoisted_12, _toDisplayString(row.l2), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[2] || (_cache[2] = _createElementVNode("span", { class: "wago-phase-label" }, "L3", -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString(row.l3), 1)
            ])
          ])
        ]))
      }), 128))
    ])
  ], 2))
}